var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { dataimpService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
import { FilterService } from "~/utils/filter.service";
var LabelingStrategyService = /** @class */ (function () {
    function LabelingStrategyService() {
    }
    /**
     * 打标队列查询
     */
    LabelingStrategyService.prototype.queryStrategyConfigPage = function (data, page) {
        return this.netService.send({
            server: dataimpService.labelingStrategyController.queryLabelingStrategy,
            data: {
                labelName: data.labelName,
                labelStatus: data.labelStatus,
                LatelyDatetimeMin: FilterService.dateRanageFormat(data.checkTime).start,
                LatelyDatetimeMax: FilterService.dateRanageFormat(data.checkTime).end
            },
            page: page
        });
    };
    /**
     * 保存更新打标队列
     */
    LabelingStrategyService.prototype.saveLabelingStrategy = function (data) {
        return this.netService.send({
            server: dataimpService.labelingStrategyController.saveLabelingStrategy,
            data: {
                labelStatus: data.labelStatus,
                labelName: data.labelName,
                formulaJson: data.formulaJson,
                id: data.id
            },
            loading: true
        });
    };
    /**
     * 查询出一条打标队列，用作查看或编辑,通过id
     * @param data
     */
    LabelingStrategyService.prototype.getOneById = function (id) {
        return this.netService.send({
            server: dataimpService.labelingStrategyController.findOneLabelingStrategy,
            data: {
                id: id
            }
        });
    };
    /**
     * 获取支持的策略字段
     */
    LabelingStrategyService.prototype.getLabelFields = function () {
        return this.netService.send({
            server: dataimpService.labelingStrategyController.getLabelFields
        });
    };
    /**
     * 执行记录查看，根据队列id查询该队列全部汇总记录
     */
    LabelingStrategyService.prototype.queryLabelDetailAll = function (data, page) {
        return this.netService.send({
            server: dataimpService.labelingStrategyController.queryLabelDetailAll,
            data: data,
            page: page
        });
    };
    /**
     * 执行记录明细查看
     */
    LabelingStrategyService.prototype.queryLabelDetailData = function (data, page) {
        return this.netService.send({
            server: dataimpService.labelingStrategyController.queryLabelDetailData,
            data: data,
            page: page
        });
    };
    /**
     * 获取Label标签数据
     */
    LabelingStrategyService.prototype.getLabelNameList = function () {
        return this.netService.send({
            server: dataimpService.labelingStrategyController.getLabelNameList
        });
    };
    /**
     * 作废/终止
     * @param data
     */
    LabelingStrategyService.prototype.updateLabelStatus = function (data) {
        return this.netService.send({
            server: dataimpService.labelingStrategyController.updateLabelStatus,
            data: {
                id: data.id,
                labelStatus: data.labelStatus
            }
        });
    };
    /**
     * 手动执行催收队列
     */
    LabelingStrategyService.prototype.manualLabel = function () {
        return this.netService.send({
            server: dataimpService.labelingStrategyController.manualLabel,
        });
    };
    __decorate([
        Inject(NetService)
    ], LabelingStrategyService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], LabelingStrategyService.prototype, "saveLabelingStrategy", null);
    return LabelingStrategyService;
}());
export { LabelingStrategyService };
